const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || "G-J2ZNCNK3TZ";

export function initGoogleAnalytics(): void {
  if (!import.meta.env.PROD) return;
  if (!GA_MEASUREMENT_ID) return;

  const w = window as Window & {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  };

  w.dataLayer = w.dataLayer ?? [];
  w.gtag = function gtag(...args: unknown[]) {
    w.dataLayer!.push(args);
  };

  w.gtag("js", new Date());
  w.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

/** Called on each client-side navigation (see App `Root`). */
export function gaTrackPageView(pagePath: string): void {
  if (!import.meta.env.PROD) return;
  const w = window as Window & { gtag?: (...args: unknown[]) => void };
  if (!w.gtag) return;
  w.gtag("config", GA_MEASUREMENT_ID, { page_path: pagePath });
}
